import { useLoad } from '@gogame/query';

import { loadOutsourceStudio } from 'scenes/Gallery/GalleryPage/OutsourceStudios/sources/outsourceStudio';

import { model } from './queryKeyFactory';

export const useOutsourceStudio = ({ id }) => {
  return useLoad(model(id), () => loadOutsourceStudio({ id }));
};
